import React, { Children, useEffect, useState } from 'react';
import styled from 'styled-components';
import { ProgressionTypes } from 'utils/activityPlan';
import { ProgressionStage } from '../ProgressionStage';
import { PerisurgicalWeekHeader } from './PerisurgicalWeekHeader';

export interface PerisurgicalWeekProps {
  id: string;
  children?: React.ReactNode | null;
  week: number;
  estimatedTime: number;
  current?: boolean | null;
  onCopyUniqueExercises: () => void;
  onCopyAllExercises: () => void;
  canCopyExercises: boolean;
  expanded: boolean;
}

const EmptyWeek = styled.div`
  padding: ${({ theme }) => theme.spacing(2)};
  text-align: center;
`;

export const PerisurgicalWeek = ({
  id,
  week,
  current,
  estimatedTime,
  children,
  onCopyAllExercises,
  onCopyUniqueExercises,
  canCopyExercises,
  expanded
}: PerisurgicalWeekProps): JSX.Element => {
  const [localExpanded, setExpanded] = useState<boolean>(expanded);
  const hasChildren = children && Children.toArray(children).length;

  useEffect(() => {
    setExpanded(expanded);
  }, [expanded]);

  return (
    <ProgressionStage
      expanded={localExpanded}
      id={`${ProgressionTypes.perisurgical}${week}`}
      header={
        <PerisurgicalWeekHeader
          id={id}
          week={week}
          estimatedTime={estimatedTime}
          current={current}
          onToggleCollapse={() => setExpanded(!localExpanded)}
          canCopyExercises={canCopyExercises}
          onCopyAllExercises={onCopyAllExercises}
          onCopyUniqueExercises={onCopyUniqueExercises}
          expanded={localExpanded}
        />
      }
    >
      {hasChildren ? (
        children
      ) : (
        <EmptyWeek>There are no exercises in this week.</EmptyWeek>
      )}
    </ProgressionStage>
  );
};
